module.exports = __webpack_public_path__ + "powered_by_blumar.png?924bf6d8dd85f52eebc5fd9025d4dfc6";


//////////////////
// WEBPACK FOOTER
// ./static/powered_by_blumar.png
// module id = 826
// module chunks = 0